module.exports = __webpack_public_path__ + "img/bowling-ball-pin.59838b7d.svg";